"use strict";
'use client';
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var index_1 = __importDefault(require("./Control/index"));
var DropdownIndicator_1 = __importDefault(require("./DropdownIndicator"));
var index_2 = __importDefault(require("./Option/index"));
// import { Label } from '../Label'
var apps_shared_1 = require("@l2p/apps-shared");
var next_intl_1 = require("next-intl");
var react_select_1 = __importDefault(require("react-select"));
require("./styles.scss");
var selectStyles = {
    control: function (css) { return (__assign(__assign({}, css), { paddingLeft: '1rem' })); },
};
var groupStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
};
var formatGroupLabel = function (data) { return (react_1.default.createElement("div", { style: groupStyles },
    react_1.default.createElement("span", null, data.label))); };
var InputSelect = function (_a) {
    var _b = _a.alignLabel, alignLabel = _b === void 0 ? 'top' : _b, labelText = _a.labelText, inputName = _a.inputName, onChange = _a.onChange, callSubmit = _a.callSubmit, placeholder = _a.placeholder, isMulti = _a.isMulti, isClearable = _a.isClearable, hasError = _a.hasError, isSearchable = _a.isSearchable, _c = _a.hideSelectedOptions, hideSelectedOptions = _c === void 0 ? true : _c, 
    // helperButton,
    tooltip = _a.tooltip, _d = _a.mode, mode = _d === void 0 ? 'dark' : _d, props = __rest(_a, ["alignLabel", "labelText", "inputName", "onChange", "callSubmit", "placeholder", "isMulti", "isClearable", "hasError", "isSearchable", "hideSelectedOptions", "tooltip", "mode"]);
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var t = (0, next_intl_1.useTranslations)('translation');
    var onChangeHandler = (0, react_1.useCallback)(function (event) {
        if (onChange)
            onChange(event);
        if (callSubmit)
            callSubmit();
    }, [callSubmit, onChange]);
    return (react_1.default.createElement("div", { className: "mainWrapper ".concat(mode === 'dark' ? 'dark' : '', " ").concat(hasError ? 'error' : '') },
        react_1.default.createElement("div", { className: "selectWrapper" },
            react_1.default.createElement(react_select_1.default, __assign({}, props, { isClearable: Boolean(isClearable), options: props.options, noOptionsMessage: function () { return t('emptyOptions'); }, isLoading: false, classNamePrefix: "react-select", isSearchable: breakpoints.mobile ? false : isSearchable, placeholder: placeholder ? placeholder : t('select'), onChange: onChangeHandler, 
                // menuIsOpen={true}
                components: {
                    DropdownIndicator: DropdownIndicator_1.default,
                    Option: index_2.default,
                    Control: index_1.default,
                }, styles: selectStyles, formatGroupLabel: formatGroupLabel })))));
};
exports.default = react_1.default.memo(InputSelect);
